import React, { useEffect } from 'react';
import { Route, Routes, useNavigate } from 'react-router-dom';
import { Bahnhofsgeographie } from '../Bahnhofsgeographie/Bahnhofsgeographie';
import Menu from '../Menubar/Menu';
import Einwohner from './Einwohner/Einwohner';
import { Categories } from '../MainMenu/MenüSicht';
import InfraMap from './InfraMap/InfraMap';

var MonitorApi = require('monitor-api');

export default function Reporting({ myApiClient, setSection }) {
  const navigate = useNavigate();

  var bildInstance = new MonitorApi.BildchenApi(myApiClient);
  var tgInstance = new MonitorApi.TagesgruppeZuJahrApi(myApiClient);
  var zvInstance = new MonitorApi.ZweckverbandApi(myApiClient);

  var aktuelleBhfInstance = new MonitorApi.AktuelleBahnhoefeApi(myApiClient);
  var hsInstance = new MonitorApi.HaltestellenApi(myApiClient);

  var bhfInstance = new MonitorApi.BahnhofApi(myApiClient);
  var strInstance = new MonitorApi.StreckeApi(myApiClient);
  var strVerlInstance = new MonitorApi.StreckenverlaufApi(myApiClient);
  var linInstance = new MonitorApi.LinieApi(myApiClient);
  var linVerlInstance = new MonitorApi.LinienverlaufApi(myApiClient);

  useEffect(() => {
    setSection('Reporting');
  }, [setSection]);

  const clickReport = e => {
    e.preventDefault();
    navigate(`../reporting/${e.target.value}`, { replace: true });
  }

  return (
    <div className="next-to-menu">
      <Menu />
      <Categories>
        <div className="SDMenu">
          <button value="einwohner" onClick={clickReport}>Einwohner der Zweckverbände</button>
          <button value="inframap" onClick={clickReport}>InfraMap</button>
          <button value="zugangsstellen" onClick={clickReport}>Lage und Einzugsbereiche der Zugangsstellen</button>
        </div>
        {/* <Bahnhofsgeographie instance={aktuelleBhfInstance} hsInstance={hsInstance}/> */}
        {/* <Einwohner bildInstance={bildInstance} jahrInstance={jahrInstance} zvInstance={zvInstance}/> */}

        <Routes>
          <Route path={'/einwohner'} element={<Einwohner bildInstance={bildInstance} tgInstance={tgInstance} zvInstance={zvInstance} />} />
          <Route path={'/inframap'} element={<InfraMap bhfInstance={bhfInstance} strInstance={strInstance} strVerlInstance={strVerlInstance} linInstance={linInstance} linVerlInstance={linVerlInstance} />} />
          <Route path={'/zugangsstellen'} element={<Bahnhofsgeographie instance={aktuelleBhfInstance} hsInstance={hsInstance} />} />
        </Routes>
      </Categories>
    </div>
  );
}
